import { Component, OnInit, HostListener, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ElectronService } from '@app/services/electron.service';

@Component({
  selector: 'app-electron-zoom',
  templateUrl: './electron-zoom.component.html',
  imports: [FormsModule],
})
export class ElectronZoomComponent implements OnInit {
  private electronService = inject(ElectronService);

  zoomFactors = this.electronService.zoomFactors;
  currentZoomIndex = this.electronService.currentZoomIndex;

  async ngOnInit() {
    // Set the current zoom index based on the value fetched from the service
    this.currentZoomIndex = await this.electronService.getZoomIndex();
  }

  // Handle zoom change via select input
  onZoomChange() {
    this.setZoomFactor();
  }

  @HostListener('window:keydown', ['$event'])
  async onKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && (event.key === '+' || event.key === '=' || event.key === '-' || event.key === '0')) {
      event.preventDefault(); // Prevent the default browser zoom behavior
      this.currentZoomIndex = await this.electronService.getZoomIndex();

      if (event.key === '+' || event.key === '=') {
        this.currentZoomIndex = Math.min(this.currentZoomIndex + 1, this.zoomFactors.length - 1);
      } else if (event.key === '-') {
        this.currentZoomIndex = Math.max(this.currentZoomIndex - 1, 0);
      } else if (event.key === '0') {
        this.currentZoomIndex = 8; // Reset to default zoom
      }

      this.setZoomFactor();
    }
  }

  // Update the zoom factor based on the selected zoom index
  setZoomFactor() {
    this.electronService.setZoomFactor(this.zoomFactors[this.currentZoomIndex]);
  }
}
